import { Box, Skeleton } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CommentPlaceholder = function CommentPlaceholder() {
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row'
    },
    "data-element": "Box",
    "data-component": "CommentPlaceholder",
    "data-source-file": "comment-placeholder.tsx",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      variant: "circular",
      width: 40,
      height: 40,
      "data-element": "Skeleton",
      "data-component": "CommentPlaceholder",
      "data-source-file": "comment-placeholder.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: 1,
        ml: 2
      },
      "data-element": "Box",
      "data-source-file": "comment-placeholder.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        variant: "rectangular",
        height: 16,
        width: "25%",
        "data-element": "Skeleton",
        "data-source-file": "comment-placeholder.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "rectangular",
        height: 16,
        width: "50%",
        "data-element": "Skeleton",
        "data-source-file": "comment-placeholder.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "rectangular",
        height: 16,
        width: "50%",
        "data-element": "Skeleton",
        "data-source-file": "comment-placeholder.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "rectangular",
        height: 16,
        width: "15%",
        "data-element": "Skeleton",
        "data-source-file": "comment-placeholder.tsx"
      })]
    })]
  });
};

export default CommentPlaceholder;